/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  WlResultTypeEnum,
  WlResultTypeEnumOptional,
  WlResultTypeEnumMetaI,
  WlResultTypeEnumTrackedI,
} from "./wl-result-type-enum";
import {
  WlResultTypeEnumTracked,
  WlResultTypeEnumMeta,
} from "./wl-result-type-enum";

/**
 *
 * @export
 * @interface UnifiedClassWlResultBase
 */
export interface UnifiedClassWlResultBaseOptional {
  /**
   *
   * @type {string}
   * @memberof UnifiedClassWlResultBase
   */
  foVmDatetime?: Date;
  /**
   *
   * @type {WlResultTypeEnum}
   * @memberof UnifiedClassWlResultBase
   */
  wlResult?: WlResultTypeEnum;
  /**
   *
   * @type {string}
   * @memberof UnifiedClassWlResultBase
   */
  offerExpDatetime?: Date;
  /**
   *
   * @type {string}
   * @memberof UnifiedClassWlResultBase
   */
  foAlertDatetime?: Date;
  /**
   *
   * @type {boolean}
   * @memberof UnifiedClassWlResultBase
   */
  permitOvercrowd?: boolean;
}

export interface UnifiedClassWlResultBase extends UnifiedClassWlResultBaseOptional {
  /**
   *
   * @type {string}
   * @memberof UnifiedClassWlResultBase
   */
  foVmDatetime?: Date;
  /**
   *
   * @type {WlResultTypeEnum}
   * @memberof UnifiedClassWlResultBase
   */
  wlResult?: WlResultTypeEnum;
  /**
   *
   * @type {string}
   * @memberof UnifiedClassWlResultBase
   */
  offerExpDatetime?: Date;
  /**
   *
   * @type {string}
   * @memberof UnifiedClassWlResultBase
   */
  foAlertDatetime?: Date;
  /**
   *
   * @type {boolean}
   * @memberof UnifiedClassWlResultBase
   */
  permitOvercrowd?: boolean;
}

export interface UnifiedClassWlResultBaseTrackedI {
  /**
   *
   * @type {string}
   * @memberof UnifiedClassWlResultBase
   */
  foVmDatetime?: Date;
  foVmDatetimeIsSet: boolean;
  /**
   *
   * @type {WlResultTypeEnum}
   * @memberof UnifiedClassWlResultBase
   */
  wlResult?: WlResultTypeEnum;
  wlResultIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof UnifiedClassWlResultBase
   */
  offerExpDatetime?: Date;
  offerExpDatetimeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof UnifiedClassWlResultBase
   */
  foAlertDatetime?: Date;
  foAlertDatetimeIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UnifiedClassWlResultBase
   */
  permitOvercrowd?: boolean;
  permitOvercrowdIsSet: boolean;
}

transformDatesMap.set(
  "UnifiedClassWlResultBase",
  function (model: UnifiedClassWlResultBase) {
    if (typeof model.foVmDatetime == "string")
      model.foVmDatetime = new Date(model.foVmDatetime);
    if (typeof model.offerExpDatetime == "string")
      model.offerExpDatetime = new Date(model.offerExpDatetime);
    if (typeof model.foAlertDatetime == "string")
      model.foAlertDatetime = new Date(model.foAlertDatetime);
  },
);

export type UnifiedClassWlResultBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: true
  foVmDatetime: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  wlResult: PropertyMeta<WlResultTypeEnumMetaI>;
  //isDate: false
  //isDatetime: true
  offerExpDatetime: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  foAlertDatetime: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  permitOvercrowd: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var UnifiedClassWlResultBaseMeta: UnifiedClassWlResultBaseMetaI =
  {} as UnifiedClassWlResultBaseMetaI;
UnifiedClassWlResultBaseMeta = typeMeta("UnifiedClassWlResultBase", {
  foVmDatetime: propertyMeta(
    "foVmDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  wlResult: propertyMeta("wlResult", false, false, false, WlResultTypeEnumMeta),
  offerExpDatetime: propertyMeta(
    "offerExpDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  foAlertDatetime: propertyMeta(
    "foAlertDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  permitOvercrowd: propertyMeta(
    "permitOvercrowd",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
});

const metaI = UnifiedClassWlResultBaseMeta;

registerMeta(() => {});

export class UnifiedClassWlResultBaseTracked implements UnifiedClassWlResultBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  foVmDatetime__I?: Date = undefined;
  foVmDatetimeIsSet: boolean = false;
  set foVmDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.foVmDatetime__I = v;
      this.foVmDatetimeIsSet = true;
    } else {
      this.foVmDatetime__I = v || undefined;
      this.foVmDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get foVmDatetime() {
    return this.foVmDatetime__I;
  }
  wlResult__I?: WlResultTypeEnum = undefined;
  wlResultIsSet: boolean = false;
  set wlResult(v: undefined | WlResultTypeEnum) {
    if (v !== undefined) {
      this.wlResult__I = v;
      this.wlResultIsSet = true;
    } else {
      this.wlResult__I = v || undefined;
      this.wlResultIsSet = false;
    }
    this.changeTracker = true;
  }
  get wlResult() {
    return this.wlResult__I;
  }
  offerExpDatetime__I?: Date = undefined;
  offerExpDatetimeIsSet: boolean = false;
  set offerExpDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.offerExpDatetime__I = v;
      this.offerExpDatetimeIsSet = true;
    } else {
      this.offerExpDatetime__I = v || undefined;
      this.offerExpDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get offerExpDatetime() {
    return this.offerExpDatetime__I;
  }
  foAlertDatetime__I?: Date = undefined;
  foAlertDatetimeIsSet: boolean = false;
  set foAlertDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.foAlertDatetime__I = v;
      this.foAlertDatetimeIsSet = true;
    } else {
      this.foAlertDatetime__I = v || undefined;
      this.foAlertDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get foAlertDatetime() {
    return this.foAlertDatetime__I;
  }
  permitOvercrowd__I?: boolean = undefined;
  permitOvercrowdIsSet: boolean = false;
  set permitOvercrowd(v: undefined | boolean) {
    if (v !== undefined) {
      this.permitOvercrowd__I = v;
      this.permitOvercrowdIsSet = true;
    } else {
      this.permitOvercrowd__I = v || undefined;
      this.permitOvercrowdIsSet = false;
    }
    this.changeTracker = true;
  }
  get permitOvercrowd() {
    return this.permitOvercrowd__I;
  }
  constructor(
    config?: UnifiedClassWlResultBaseOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: UnifiedClassWlResultBaseOptional,
    options?: AssignOptions,
  ): UnifiedClassWlResultBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.foVmDatetime &&
      this.foVmDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.foVmDatetime = config.foVmDatetime;
      if (optionsRequired.unassign) this.foVmDatetimeIsSet = false;
      else this.foVmDatetimeIsSet = true;
    }
    if (config.wlResult && this.wlResultApplyFilter(optionsRequired.filter)) {
      this.wlResult = config.wlResult;
      if (optionsRequired.unassign) this.wlResultIsSet = false;
      else this.wlResultIsSet = true;
    }
    if (
      config.offerExpDatetime &&
      this.offerExpDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.offerExpDatetime = config.offerExpDatetime;
      if (optionsRequired.unassign) this.offerExpDatetimeIsSet = false;
      else this.offerExpDatetimeIsSet = true;
    }
    if (
      config.foAlertDatetime &&
      this.foAlertDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.foAlertDatetime = config.foAlertDatetime;
      if (optionsRequired.unassign) this.foAlertDatetimeIsSet = false;
      else this.foAlertDatetimeIsSet = true;
    }
    if (
      config.permitOvercrowd &&
      this.permitOvercrowdApplyFilter(optionsRequired.filter)
    ) {
      this.permitOvercrowd = config.permitOvercrowd;
      if (optionsRequired.unassign) this.permitOvercrowdIsSet = false;
      else this.permitOvercrowdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): UnifiedClassWlResultBaseTrackedI {
    const cloned = {} as UnifiedClassWlResultBaseTrackedI;
    if (
      this.foVmDatetimeIsSetDeep() &&
      this.foVmDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.foVmDatetimeIsSet = true;
      cloned.foVmDatetime = this.foVmDatetime;
    } else {
      //cloned.foVmDatetimeIsSet = false
    }
    if (
      this.wlResultIsSetDeep() &&
      this.wlResultApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.wlResultIsSet = true;
      cloned.wlResult = this.wlResult;
    } else {
      //cloned.wlResultIsSet = false
    }
    if (
      this.offerExpDatetimeIsSetDeep() &&
      this.offerExpDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.offerExpDatetimeIsSet = true;
      cloned.offerExpDatetime = this.offerExpDatetime;
    } else {
      //cloned.offerExpDatetimeIsSet = false
    }
    if (
      this.foAlertDatetimeIsSetDeep() &&
      this.foAlertDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.foAlertDatetimeIsSet = true;
      cloned.foAlertDatetime = this.foAlertDatetime;
    } else {
      //cloned.foAlertDatetimeIsSet = false
    }
    if (
      this.permitOvercrowdIsSetDeep() &&
      this.permitOvercrowdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.permitOvercrowdIsSet = true;
      cloned.permitOvercrowd = this.permitOvercrowd;
    } else {
      //cloned.permitOvercrowdIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): UnifiedClassWlResultBaseTrackedI {
    if (!this.foVmDatetimeApplyFilter(filter)) this.foVmDatetimeIsSet = false;

    if (!this.wlResultApplyFilter(filter)) this.wlResultIsSet = false;

    if (!this.offerExpDatetimeApplyFilter(filter))
      this.offerExpDatetimeIsSet = false;

    if (!this.foAlertDatetimeApplyFilter(filter))
      this.foAlertDatetimeIsSet = false;

    if (!this.permitOvercrowdApplyFilter(filter))
      this.permitOvercrowdIsSet = false;

    return this;
  }
  foVmDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassWlResultBaseMeta.foVmDatetime,
      UnifiedClassWlResultBaseMeta,
      this.foVmDatetime,
      this,
    );
  }
  foVmDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.foVmDatetimeIsSet && this.foVmDatetimeApplyFilter(filter))
      return true;

    return false;
  }
  wlResultApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassWlResultBaseMeta.wlResult,
      UnifiedClassWlResultBaseMeta,
      this.wlResult,
      this,
    );
  }
  wlResultIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.wlResultIsSet && this.wlResultApplyFilter(filter)) return true;

    return false;
  }
  offerExpDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassWlResultBaseMeta.offerExpDatetime,
      UnifiedClassWlResultBaseMeta,
      this.offerExpDatetime,
      this,
    );
  }
  offerExpDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.offerExpDatetimeIsSet && this.offerExpDatetimeApplyFilter(filter))
      return true;

    return false;
  }
  foAlertDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassWlResultBaseMeta.foAlertDatetime,
      UnifiedClassWlResultBaseMeta,
      this.foAlertDatetime,
      this,
    );
  }
  foAlertDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.foAlertDatetimeIsSet && this.foAlertDatetimeApplyFilter(filter))
      return true;

    return false;
  }
  permitOvercrowdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassWlResultBaseMeta.permitOvercrowd,
      UnifiedClassWlResultBaseMeta,
      this.permitOvercrowd,
      this,
    );
  }
  permitOvercrowdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.permitOvercrowdIsSet && this.permitOvercrowdApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.foVmDatetimeIsSetDeep(filter)) return true;
    if (this.wlResultIsSetDeep(filter)) return true;
    if (this.offerExpDatetimeIsSetDeep(filter)) return true;
    if (this.foAlertDatetimeIsSetDeep(filter)) return true;
    if (this.permitOvercrowdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
